import { render } from "./offer.label.vue?vue&type=template&id=51f30b60"
import script from "./offer.label.vue?vue&type=script&lang=js"
export * from "./offer.label.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__